import { render } from "./ProductInfo.vue?vue&type=template&id=239e3840&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=239e3840&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239e3840"],['__file',"resources/js/modules/product-submission/components/filter/ProductInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "239e3840"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('239e3840', __exports__)) {
    api.reload('239e3840', __exports__)
  }
  
  module.hot.accept("./ProductInfo.vue?vue&type=template&id=239e3840&scoped=true", () => {
    api.rerender('239e3840', render)
  })

}


export default __exports__